module.exports = __webpack_public_path__ + "static/media/BagsLicenseIcon.9f3f6856.svg";